import styled from "styled-components"
import theme from "../../styles/theme"
import React from "react"
import PropTypes from "prop-types"

const StyledWrapper = styled.div`
  display: grid;
  grid-gap: 1rem;
  grid-template-columns: repeat(auto-fit, minmax(100px, 1fr));
  background-color: ${theme.color.indigo100};
  border-radius: 1rem;
  padding: 4rem;
  align-items: center;
  margin-bottom: 2rem;

  .klipfolio-image-wrapper {
    margin: 0 auto;
    margin-bottom: 0 !important;
    margin-top: 0 !important;
    height: min-content;
    overflow: visible;
    img {
      box-shadow: ${({ shadow }) => shadow && theme.shadow.dramatic};
      max-height: 400px;
      border-radius: 1rem;
    }
  }
`

const ImageWrapper = ({ shadow = true, children }) => (
  <StyledWrapper shadow={shadow}>{children}</StyledWrapper>
)

ImageWrapper.propTypes = {
  shadow: PropTypes.bool,
  children: PropTypes.node.isRequired,
}

export default ImageWrapper
